import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where
} from "firebase/firestore";
import { db } from "../../../lib/firebaseConfig";
import { IdVerification, UserFullInfo } from "../../../types/user";

const getUser = async (uid: string, collectionName: string) => {
  const q = query(collection(db, collectionName), where("uid", "==", uid));
  const querySnapshot = await getDocs(q);
  const length = querySnapshot.docs.length;
  if (length !== 0) {
    return querySnapshot.docs[0].data() as any;
  } else {
    return null;
  }
};

const checkAgeConfirmation = (
  idVerifications: IdVerification[],
  ageConfirmation: boolean
) => {
  if (ageConfirmation) return true;
  if (idVerifications?.length > 0) {
    const approved = idVerifications.find(
      (item: IdVerification) => item.approvedAt
    );
    return !!approved;
  }
  return false;
};

//　一意のユーザを取得する
export const listenUser = async (
  uid: string,
  dispatchUser: React.Dispatch<React.SetStateAction<UserFullInfo | null>>,
  returnMember?: boolean
) => {
  try {
    // console.log("listenUser🔥", uid);
    // ref: https://firebase.google.cn/docs/firestore/query-data/queries?hl=ja#execute_a_query
    const memberDoc = await getDoc(doc(db, "Members", uid));
    const member = memberDoc.data() as any;
    const idVerifications: IdVerification[] = member?.idVerifications ?? [];
    let user;
    if (member?.profileCollectionName) {
      user = await getUser(uid, member.profileCollectionName);
    } else {
      const userMen = await getUser(uid, "UserMen");
      if (userMen) {
        user = userMen;
      } else {
        user = await getUser(uid, "UserWomen");
      }
    }
    const ageConfirmation = checkAgeConfirmation(
      idVerifications,
      user?.ageConfirmation
    );
    const mergedUser = { ...user, ageConfirmation };

    if (dispatchUser) {
      dispatchUser(mergedUser);
    }
    if (Boolean(returnMember)) {
      return { userInfo: mergedUser, member };
    }
    return mergedUser;
  } catch {
    return {};
  }
};
